import {
  Arrange,
  Icon,
  IconButton,
  SvgClose,
  SvgDownload,
  Text,
} from '@loomhq/lens';
import cn from 'classnames';
import React from 'react';
import CircularProgressbar from 'react-circular-progressbar';
import { useDispatch, useSelector } from 'react-redux';

import { abortDownload } from 'creators/header';

import { selectDownloading } from 'selectors/header';

import styles from './styles.module.less';

export default function DownloadProgress() {
  const { percent, isDownloading } = useSelector(selectDownloading);
  const dispatch = useDispatch();

  if (!isDownloading) {
    return null;
  }

  return (
    <div className={cn('theme-dark', styles.wrapper)}>
      <Arrange gap="medium">
        <div className={styles.progressWrapper}>
          <CircularProgressbar
            percentage={percent}
            strokeWidth={8}
            styles={{
              path: {
                stroke: 'var(--lns-color-success)',
              },
              trail: {
                stroke: 'white',
              },
            }}
          />

          <Icon icon={<SvgDownload />} />
        </div>
        <Text color="body">Downloading video...</Text>
        <IconButton
          altText="Close"
          icon={<SvgClose />}
          onClick={() => dispatch(abortDownload())}
        />
      </Arrange>
    </div>
  );
}
